var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39086 4.45715L3.47343 10.3746L2.6665 13.3333L5.62522 12.5264L11.5426 6.60894M9.39086 4.45715L10.7357 3.11228C10.877 2.97099 11.0447 2.85891 11.2294 2.78245C11.414 2.70598 11.6118 2.66663 11.8116 2.66663C12.0114 2.66663 12.2093 2.70598 12.3939 2.78245C12.5785 2.85891 12.7462 2.97099 12.8875 3.11228C13.0288 3.25357 13.1409 3.4213 13.2173 3.6059C13.2938 3.7905 13.3332 3.98836 13.3332 4.18817C13.3332 4.38799 13.2938 4.58584 13.2173 4.77044C13.1409 4.95505 13.0288 5.12278 12.8875 5.26407L11.5426 6.60894M9.39086 4.45715L11.5426 6.60894",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d2e280314d7105f214892fbd1bbd499c.svg";
export { ForwardRef as ReactComponent };